import React from 'react';
import { Row, Col, Typography } from 'antd';

const { Text } = Typography;

import * as recurrence from '../../../../constants/recurrence-constants';

import ChoiceLine from '../form-wrappers/choice-line';

import ByMonthItem from '../form-items/byMonth-item';
import ByMonthDayItem from '../form-items/byMonthDay-item';

const ByMonthAndByMonthDayChoise = ({ requiredItems, selectedChoice, isRadioGroup, rootContainer }) => {
  const complexChoiceSizes = { span: 24, offset: 0, prefix: { span: 4, offset: 0 }, child: { span: 15, offset: 0 }, suffix: { span: 5, offset: 0 } };
  const choiceLineValue = 'byMonth_byMonthDay';

  return (
    <ChoiceLine sizes={complexChoiceSizes} prefix={{ isRadioGroup: isRadioGroup, label: 'Every', value: choiceLineValue }}>
      <Row className="recurrence-row">
        <Col span={11}>
          <ByMonthItem
            rootContainer={rootContainer}
            selectedChoice={selectedChoice}
            choiceLineValue={choiceLineValue}
            requiredItems={requiredItems}
            isRadioGroup={isRadioGroup}
          />
        </Col>

        <Col span={2}>
          <Text className="recurrence-text recurrence-additional-text">{'on'}</Text>
        </Col>

        <Col span={8}>
          <ByMonthDayItem
            rootContainer={rootContainer}
            selectedChoice={selectedChoice}
            choiceLineValue={choiceLineValue}
            requiredItems={requiredItems}
            isRadioGroup={isRadioGroup}
            inputType={recurrence.INPUT_TYPES.INPUT_NUMBER}
          />
        </Col>

        <Col span={3}>
          <Text className="recurrence-text recurrence-additional-text">{'day'}</Text>
        </Col>
      </Row>
    </ChoiceLine>
  );
};
export default ByMonthAndByMonthDayChoise;
